module.exports = require("@native-ads/antd/");


//////////////////
// WEBPACK FOOTER
// external "@native-ads/antd/"
// module id = 115
// module chunks = 0